import { createApi } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../config';
import { createBaseQueryWithAuth } from './baseQueryWithAuth';

interface Sprint {
  _id: string;
  name: string;
  date: string;
  fileName: string;
  sprint: string;
  status: string;
  filePath: string;
  extractedData?: Record<string, any>;
}

export const sprintApi = createApi({
  reducerPath: 'sprintApi',
  baseQuery: createBaseQueryWithAuth(`${API_BASE_URL}/sprints`),
  tagTypes: ['Sprint'],
  endpoints: (builder) => ({
    createSprint: builder.mutation<Sprint, FormData>({
      query: (sprintData) => ({
        url: '/',
        method: 'POST',
        body: sprintData,
      }),
      invalidatesTags: ['Sprint'],
    }),
    getSprints: builder.query<Sprint[], void>({
      query: () => '/',
      providesTags: ['Sprint'],
    }),
    getSprintById: builder.query<Sprint, string>({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: 'Sprint', id }],
    }),
    publishBlog: builder.mutation<void, string>({
      query: (sprintId) => ({
        url: `/publish/${sprintId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Sprint'],
    }),
    deleteSprint: builder.mutation<{ message: string; _id: string }, string>({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Sprint'],
    }),
  }),
});

export const {
  useCreateSprintMutation,
  useGetSprintsQuery,
  useGetSprintByIdQuery,
  usePublishBlogMutation,
  useDeleteSprintMutation,
} = sprintApi;
